import { useState, useEffect } from 'react';
import { SingleTrail, TrailDifficulty, TrailStatus } from '../../../Resources/Data/Trails';
import { trailService } from '../services/trailService';

export const useTrail = (id?: string) => {
  const [trail, setTrail] = useState<SingleTrail>({
    startingPoint: { coordinates: [0, 0], type: "Point" },
    photos: [],
    description: "",
    trailPath: { type: "LineString", coordinates: [] },
    name: "",
    id: 0,
    status: TrailStatus.Pending,
    distance: 0,
    difficulty: TrailDifficulty.Easy,
    type: undefined,
    carType: undefined,
    time: "0 hours 0 minutes",
    rating: 0,
    cityId: 0,
    createdAt: new Date()
  });
  const [originalTrail, setOriginalTrail] = useState<SingleTrail>();
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(id !== undefined);

  useEffect(() => {
    if (!id) {
      setIsEditing(false);
      return;
    }

    trailService.getTrail(id)
      .then((response) => {
        const trailData = response.data.trail;
        setTrail(trailData);
        setOriginalTrail(trailData);
      })
      .catch(() => {
        alert("Error loading trail data");
      });
  }, [id]);

  const setNewTrailValue = <K extends keyof SingleTrail>(
    key: K,
    value: SingleTrail[K]
  ) => {
    setTrail((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return {
    trail,
    setTrail,
    originalTrail,
    setOriginalTrail,
    loading,
    setLoading,
    isEditing,
    setNewTrailValue,
  };
}; 